import { TableExtractPtBr } from "./table-extract-pt-br";

export const TABLE_EXTRACT_ES_MX: TableExtractPtBr = {
	consolidated: {
		title: "Periodo Consolidado",
		totalTitle: "Total de periodo de {{period}}",
		tooltip: "¿Qué es el resumen de competencia?",
		tooltipDescription:
			"Operaciones agrupadas por la fecha en que la operación o evento económico realmente ocurrió.",
	},
	cashFlow: {
		title: "Transacciones del período",
		totalTitle: "Saldo Final Liquidado del período",
		tooltip: "¿Qué es el resumen de transacciones?",
		tooltipDescription:
			"Operaciones de transacciones realizadas durante el período seleccionado.",
	},
	tpv: {
		title: "TPV Consolidado",
		totalTitle: "Total TPV",
		tooltip: "¿Qué es el TPV?",
		tooltipDescription:
			"Total de transacciones procesadas en el período seleccionado (Terminal Point of Value).",
	},
	total: "Total",
	name: "Descripción",
	value: "Valor",
	grossValue: "Valor Bruto",
	netValue: "Valor Líquido",
	tax: "Impuesto",
	from: "De",
	to: "a",
	group: "Agrupación",
	excel: {
		title:
			"Informe Consolidado por Período de Transacciones y Consolidado de Competencia  {{startDate}} a {{endDate}}",
		fileName: "informe_consolidado_transacciones_{{startDate}}_a_{{endDate}}.xlsx",
	},
	withdrawalsPeriod: "Transacciones del período",
	competenceConsolidated: "Consolidado de Competencia",
	notLiquidatedTransactions: "Transacciones no liquidadas del período",
	anticipatedValue: "Valor Anticipado",
	obs: "Observación",
};
